/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'closing': {
    width: 16,
    height: 16,
    viewBox: '0 0 47.71 47.71',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M26.62 21.08L.35 47.35M47.35.35L33.12 14.58M.35.35l47 47"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/closing.js